import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle, { DialogTitleProps } from '@mui/material/DialogTitle';
import MUIModal, { ModalProps as MUIModalProps } from '@mui/material/Modal';

export interface ModalProps extends MUIModalProps {
  onClose: () => void;
  title: string;
  titleIcon?: JSX.Element;
  maxWidth?: boolean;
  titleColor?: DialogTitleProps['color'];
}

export const Modal = ({
  onClose,
  title,
  maxWidth,
  children,
  titleIcon,
  titleColor,
  ...modalProps
}: ModalProps): JSX.Element => {
  return (
    <MUIModal {...modalProps}>
      <Dialog
        open
        onClose={onClose}
        fullWidth
        maxWidth={maxWidth ? 'lg' : 'sm'}
      >
        <DialogTitle color={titleColor ?? 'inherit'} variant="h6">
          <Box gap={1} display="flex" alignItems="center">
            {titleIcon ?? null}
            {title}
          </Box>
        </DialogTitle>
        <DialogContent>
          <Box mt={1}>{children}</Box>
        </DialogContent>
      </Dialog>
    </MUIModal>
  );
};
